import React, { RefObject } from 'react'
import styled from 'styled-components'
import { Box, get, TextBody, TextHeading } from '@ally/metronome-ui'

interface WidgetProps {
  widgetTitle: string | React.ReactElement
  widgetBody: React.ReactElement
  dataTestId: string
  dataTrackMbox?: string
  titleRef?: RefObject<HTMLHeadingElement>
  widgetAriaLabel?: string
  header?: React.ReactNode
  footer?: React.ReactNode
  hideFooterBorder?: boolean
}

const WidgetTitle = styled(TextHeading)`
  font-size: ${get.fontSizes('sm')};
`

export const Widget: React.FC<WidgetProps> = ({
  widgetBody,
  widgetAriaLabel,
  widgetTitle,
  titleRef,
  header,
  footer,
  dataTestId,
  dataTrackMbox,
  hideFooterBorder,
}) => {
  return (
    <TextBody
      size="sm"
      tag="section"
      aria-label={widgetAriaLabel}
      data-testid={dataTestId}
      data-track-mbox={dataTrackMbox}
    >
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        py="sm"
        px="md"
        borderBottom="1px solid"
        borderColor="slate-1"
        lineHeight="24px"
      >
        <WidgetTitle
          tag="h2"
          size="sm"
          weight="bold"
          ref={titleRef}
          tabIndex={-1}
        >
          {widgetTitle}
        </WidgetTitle>
        {header && <Box>{header}</Box>}
      </Box>
      <Box padding="md" alignContent="center">
        {widgetBody}
      </Box>
      {footer && (
        <Box
          borderTop={hideFooterBorder ? 'none' : '1px solid'}
          borderColor="slate-1"
          py="sm"
          px="md"
        >
          {footer}
        </Box>
      )}
    </TextBody>
  )
}
